import * as React from 'react'
import { Platform, SafeAreaView, ScrollView, View } from 'react-native'
import styled from '@theme/styled-components'

import ButtonsSection from './sections/ButtonsSection'
import CheckboxesSection from './sections/CheckboxesSection'
import ChoicesSection from './sections/ChoicesSection'
import FontsSection from './sections/FontsSection'
import HeadersSection from './sections/HeadersSection'
import IconsSection from './sections/IconsSection'
import IncidentStatusesSection from './sections/IncidentStatusesSection'
import ModalsSection from './sections/ModalsSection'
import PickersSection from './sections/PickersSection'
import RadiosSection from './sections/RadiosSection'
import SectionTitlesSection from './sections/SectionTitlesSection'
import SegmentedControlsSection from './sections/SegmentedControlsSection'
// import SiteCardsSection from './sections/SiteCardsSection'
import SiteIconsSection from './sections/SiteIconsSection'
import SwitchesSection from './sections/SwitchesSection'
import TabsSection from './sections/TabsSection'
import TagsSection from './sections/TagsSection'
import TextInputsSection from './sections/TextInputsSection'
import ImageSection from './sections/ImageSection'
import SelectSection from './sections/SelectSection'
import StepsSection from './sections/StepsSection'

const StorybookScreen = () => {
  return (
    <MainContainer>
      <ScrollView>
        <FontsSection />
        <IconsSection />
        <SiteIconsSection />
        <ModalsSection />
        <ButtonsSection />
        <SwitchesSection />
        <TabsSection />
        <SegmentedControlsSection />
        <ChoicesSection />
        <TextInputsSection />
        <ZIndexContainer zIndex={0}>
          <PickersSection />
        </ZIndexContainer>
        <ZIndexContainer zIndex={-1}>
          <CheckboxesSection />
        </ZIndexContainer>
        <TagsSection />
        <IncidentStatusesSection />
        <RadiosSection />
        <SectionTitlesSection />
        {/*TODO: Problème avec les icons de site*/}
        {/*<SiteCardsSection />*/}
        <HeadersSection />
        <ImageSection />
        <SelectSection />
        <StepsSection />
      </ScrollView>
    </MainContainer>
  )
}

export default StorybookScreen

const MainContainer = styled(SafeAreaView)`
  background-color: ${(props) => props.theme.colors.backgroundTertiary};
  ${Platform.OS === 'web' &&
  `
  height: 100vh;
  width: 100vw;
  `}
`
const ZIndexContainer = styled(View)<{ zIndex: number }>`
  z-index: ${(props) => props.zIndex};
`
